import _ from 'lodash';

export default {
  form: 'comment',
  fields: ['content', 'ownerId'],
  validate: ({ content }) => {
    const hasContent = content && content.blocks && content.blocks.some(block => block.text);
    const isUploading = content && _.some(content.entityMap, entity => _.get(entity, 'data.isLoading'));

    if (!hasContent) {
      return { content: 'empty' };
    }

    if (isUploading) {
      return { image: 'loading' };
    }
  },
};



// WEBPACK FOOTER //
// ./app/services/comment-form-settings.js